/** The Get log file for a failed MCE upload: what support needs, none of the file contents. */
import saveAs from "file-saver";
import JSZip from "jszip";
import pin from "../../wasm/mce_idl/pin.json";

/** What a log records about a failed upload. */
export interface MceIdlLogInput {
  when: Date;
  action: string;
  product: string;
  files: { name: string; bytes: number }[];
  error: unknown;
}

/** The log as text. */
export function mceIdlLogText(input: MceIdlLogInput): string {
  const error =
    input.error instanceof Error
      ? { name: input.error.name, message: input.error.message }
      : String(input.error);
  return JSON.stringify(
    {
      when: input.when.toISOString(),
      action: input.action,
      product: input.product,
      files: input.files,
      error,
      converterCommit: pin.converterCommit,
      wasmSha256: pin.wasmSha256,
      userAgent: navigator.userAgent,
    },
    null,
    2,
  );
}

/** Save the log as a zip. */
export async function downloadMceIdlLog(input: MceIdlLogInput): Promise<void> {
  const zip = new JSZip();
  zip.file("mce-idl.json", mceIdlLogText(input));
  saveAs(await zip.generateAsync({ type: "blob" }), "liftnet-mce-idl-log.zip");
}
